import styled, { css } from 'styled-components';

import { buttonStylePrimary } from '~/src/common/components/Button/Variants/PrimaryButton';
import { Logo } from '~/src/common/components/Logo/Logo';
import { COLORS, ZINDEX } from '~/src/common/theme';
import { NAV_HEIGHT, media, notificationStyle } from '~/src/common/theme/deprecated';

export const StickyContainer = styled.header`
  width: 100%;
  z-index: ${ZINDEX.navigationHeader};

  display: flex;
  flex-direction: column;

  position: sticky;
  top: 0;

  background-color: ${COLORS.NEUTRAL_DEFAULT};

  ${media.XL`
    padding: 0 56px;
  `}
`;

export const CommonContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 0 16px;

  height: ${NAV_HEIGHT}px;
`;

export const LeftContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const LOGO_WIDTH = 150;

export const CenterContainer = styled.div`
  position: absolute;
  left: calc(50% - ${LOGO_WIDTH}px / 2);
  right: calc(50% - ${LOGO_WIDTH}px / 2);
  z-index: 1;

  ${media.XL`
    z-index: auto;
    position: static;
    display: block;
    flex: 1;
  `}
`;

export const RightContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0;

  ${media.XL`
    gap: 24px;
  `}
`;

export const StyledLogo = styled(Logo)`
  display: block;
  max-width: ${LOGO_WIDTH}px;
`;

export const BurgerMenuButton = styled.button`
  background: none;
  border: none;
  translate: -8px 0;
`;

export const RecipeButton = styled.a<{
  $hasNotification?: boolean;
}>`
  ${buttonStylePrimary}
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  padding: 8px;
  margin-right: 16px;

  border-radius: 4px;

  font-size: 14px;
  font-weight: 700;
  line-height: 16px;

  cursor: pointer;

  ${({ $hasNotification }) =>
    $hasNotification
      ? css`
          &::after {
            ${notificationStyle};
            content: '';
            position: absolute;
            top: 4px;
            right: 2px;
          }
        `
      : null}
`;
